// extracted by mini-css-extract-plugin
export default {"dictionarySelect":"Pharmasol_dictionarySelect__EH6Ho"};